import React from 'react';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import FAIcon from '#/common/components/FAIcon';
import ToolbarButton from '../DataGrid/ToolbarButton';
import { isLightTheme } from '#/common/utils/themeDetection';

const FileInfoCardStyles = styled.div<{ width: string }>`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  background-color: ${({ theme }) =>
    isLightTheme(theme) ? color('ui', 'light3') : color('ui', 'middle')};
  border-radius: 16px;
  width: ${({ width }) => width};
  padding: 12px;
`;

const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-right: 24px;
`;

const FileMetadata = styled.div`
  font-size: 12px;
  color: ${color('secondary', 'dark')};
`;

const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background-color: ${({ theme }) =>
    isLightTheme(theme) ? color('ui', 'light2') : color('ui', 'dark')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export interface FileInfoCardProps {
  fileName: string;
  fileSize: number;
  onDelete?: () => void;
  width?: string;
}

const FileInfoCard: React.FC<FileInfoCardProps> = ({
  fileName,
  fileSize,
  onDelete,
  width = 'fit-content',
}) => {
  return (
    <FileInfoCardStyles width={width}>
      <IconWrapper>
        <FAIcon icon="file" />
      </IconWrapper>
      <FileDetails>
        <NuvoLabel>{fileName}</NuvoLabel>
        <FileMetadata>{formatFileSize(fileSize)}</FileMetadata>
      </FileDetails>
      {onDelete && (
        <ToolbarButton
          tooltip="Clear selection"
          icon="trash"
          filled={true}
          type="danger"
          onClick={onDelete}
          disabled={false}
        />
      )}
    </FileInfoCardStyles>
  );
};

export default React.memo(FileInfoCard);
